import React, { useState, useRef, useEffect } from 'react';
import ChangePasswordModal from '../ChangePasswordModal/ChangePasswordModal';
import './UserProfileMenu.css';
import { useAuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';
import { useSpinner } from '../../context/SpinnerContext';
import logger from '../../utils/logger';

const UserProfileMenu = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const navigate = useNavigate();
    const menuRef = useRef(null);
    const [notification, setNotification] = useState({ visible: false, message: '', type: 'info' });
    const { logout, changePassword } = useAuthContext();
    const { showSpinner, hideSpinner } = useSpinner();

    const showNotification = (message, type = 'info') => {
        setNotification({ visible: true, message, type });
        setTimeout(() => {
            setNotification({ visible: false, message: '', type: 'info' });
        }, 5000);
    };
    // Cerrar menú cuando se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLogout = async () => {
        logger.info('Cerrando sesión...', {
            currentUserEmail: user?.email,
        }, 'UserProfileMenu');
        showSpinner('Cerrando sesión...');
        await logout();
        navigate('/login');
        hideSpinner();
        logger.info('Sesión cerrada exitosamente...', {
            currentUserEmail: user?.email,
        }, 'UserProfileMenu');
    };

    const handleChangePassword = () => {
        setShowChangePasswordModal(true);
    };

    const handleChangePasswordSubmit = async (passwordData) => {
        showSpinner('Cambiando contraseña...');
        logger.info('Cambiando contraseña...', {
            currentUserEmail: user?.email,
        }, 'UserProfileMenu');
        try {
            await changePassword(passwordData);
            setShowChangePasswordModal(false);
            // Si tienes un sistema de notificaciones, úsalo aquí
            showNotification('Contraseña cambiada exitosamente', 'success');
        } catch (error) {
            logger.error('Error al cambiar contraseña:', error, null, 'UserProfileMenu');
            showNotification('Error al cambiar contraseña: ' + error.message, 'error');
        } finally {
            hideSpinner();
        }
    };

    const handleProfileClick = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="user-profile-menu" ref={menuRef}>
            <button className="profile-trigger" onClick={handleProfileClick}>
                <div className="user-info">
                    <span className="user-name">{user?.name}</span>
                    <span className="user-role">{user?.role}</span>
                </div>
                <div className="profile-avatar">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </div>
                <svg
                    className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
            </button>

            {isOpen && (
                <div className="profile-dropdown">
                    <div className="dropdown-header">
                        <div className="user-details">
                            <div className="user-avatar-large">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                            </div>
                            <div className="user-info-detailed">
                                <span className="user-name-detailed">{user?.name}</span>
                                <span className="user-email">{user?.email}</span>
                                <span className="user-role-detailed">{user?.role}</span>
                            </div>
                        </div>
                    </div>

                    <div className="dropdown-divider"></div>

                    <div className="dropdown-menu">

                        <button className="menu-item" onClick={handleChangePassword}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 20h9"></path>
                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                            </svg>
                            <span>Cambiar Contraseña</span>
                        </button>
                    </div>

                    <div className="dropdown-divider"></div>

                    <div className="dropdown-menu">
                        <button className="menu-item logout-item" onClick={handleLogout}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16,17 21,12 16,7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                            <span>Cerrar Sesión</span>
                        </button>
                    </div>
                </div>
            )}
            <ChangePasswordModal
                isOpen={showChangePasswordModal}
                onClose={() => setShowChangePasswordModal(false)}
                onSubmit={handleChangePasswordSubmit}
                title="Cambiar Contraseña"
                subtitle="Ingresa tu nueva contraseña para actualizar tu cuenta"
            />
            <Notification
                visible={notification.visible}
                message={notification.message}
                type={notification.type}
            />
        </div>
    );
};

export default UserProfileMenu; 